export default "__VITE_ASSET__3cf4d688__"